import {
  Dashboard,
  People,
  Inventory,
  ShoppingCart,
  PhotoAlbum,
  ReceiptLong,
  Announcement,
  Business,
  Slideshow,
  Work,
  LocalOffer,
  Contacts,
  History,
  Store,
  Category,
  LibraryBooks
} from '@mui/icons-material';

export const mainMenuItems = [
  { 
    text: 'Dashboard', 
    icon: <Dashboard sx={{ color: 'inherit' }} />, 
    path: '/admin',
    exact: true
  },
  { 
    text: 'Master Management', 
    icon: <Business sx={{ color: 'inherit' }} />, 
    subItems: [
      { 
        text: 'Sliders', 
        icon: <Slideshow sx={{ color: 'inherit' }} />, 
        path: '/admin/sliders' 
      },
      { 
        text: 'Partners', 
        icon: <People sx={{ color: 'inherit' }} />, 
        path: '/admin/partners' 
      },
      { 
        text: 'Gallery', 
        icon: <PhotoAlbum sx={{ color: 'inherit' }} />, 
        path: '/admin/galleries' 
      },
      { 
        text: 'Dealers', 
        icon: <Store sx={{ color: 'inherit' }} />, 
        path: '/admin/dealers' 
      },
      { 
        text: 'Contact Us', 
        icon: <Contacts sx={{ color: 'inherit' }} />, 
        path: '/admin/contacts' 
      },
      { 
        text: 'Update Story', 
        icon: <History sx={{ color: 'inherit' }} />, 
        path: '/admin/stories' 
      }
    ]
  },
  { 
    text: 'Announcements',
    icon: <Announcement sx={{ color: 'inherit' }} />, 
    subItems: [
      { 
        text: 'Tenders', 
        icon: <LibraryBooks sx={{ color: 'inherit' }} />, 
        path: '/admin/tenders' 
      },
      { 
        text: 'Vacancies', 
        icon: <Work sx={{ color: 'inherit' }} />, 
        path: '/admin/vacancies' 
      },
    ]
  },
  { 
    text: 'Offers',
    icon: <LocalOffer sx={{ color: 'inherit' }} />, 
    subItems: [
      { 
        text: 'Create Offers', 
        icon: <ReceiptLong sx={{ color: 'inherit' }} />, 
        path: '/admin/offers' 
      },
    ]
  },
  { 
    text: 'Product Catalog', 
    icon: <Inventory sx={{ color: 'inherit' }} />, 
    subItems: [
      { 
        text: 'Categories', 
        icon: <Category sx={{ color: 'inherit' }} />, 
        path: '/admin/categories' 
      },
      { 
        text: 'Products', 
        icon: <ShoppingCart sx={{ color: 'inherit' }} />, 
        path: '/admin/products' 
      },
      {
        text: 'Orders',
        icon: <ReceiptLong sx={{ color: 'inherit' }} />,
        path: '/admin/orders'
      }
    ]
  }
];